module.exports = __webpack_public_path__ + "img/room2.37027298.gif";